import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const SCROLL_RETRY_INTERVAL_MS = 100;
const SCROLL_RETRY_ATTEMPTS = 5;

export const AnchorScroller = () => {
  const { pathname, hash } = useLocation();

  function scrollToTop() {
    window.scrollTo(0, 0);
  }

  useEffect(() => {
    if (!hash) {
      scrollToTop();
      return;
    }

    let attempts = 0;
    let timeoutId: ReturnType<typeof setTimeout>;

    const attemptScroll = () => {
      const scrollToElement = document.getElementById(hash.substring(1));
      const canScroll = document.body.style.overflow !== "hidden";

      if (scrollToElement && canScroll) {
        scrollToElement.scrollIntoView({ behavior: "smooth" });
        return;
      }

      attempts += 1;
      if (attempts < SCROLL_RETRY_ATTEMPTS) {
        timeoutId = setTimeout(attemptScroll, SCROLL_RETRY_INTERVAL_MS);
      } else if (!scrollToElement) {
        scrollToTop();
      }
    };

    attemptScroll();

    return () => clearTimeout(timeoutId);
  }, [pathname, hash]);

  return null;
};
